// extracted by mini-css-extract-plugin
export default {"loginBox":"components_loginBox__16HMa","loginContainer":"components_loginContainer__RXYEs"};